import { computed } from "mobx";
import { inject, observer } from "mobx-react";
// import moment from "moment";
import { useState } from "react";

import "./style.scss";
import { useParams } from "react-router-dom";

const RatesTableComponent = inject("mainStore")(
    observer(({ mainStore, items, tab = "rubPerOrder", cpl = false, confirmRemove = () => {}, handleEditRates, revenue_share = false }) => {
        const { firstParam } = useParams();
        const [all, setAll] = useState(false);

        const offers = computed(() => mainStore.getMainStore("suggest.offers_suggest")).get();

        if (revenue_share) {
            return (
                <div className="table">
                    <div className="table__head" style={{ "--countColumns": "3" }}>
                        <div className="name">
                            <span>Процент от суммы</span>
                        </div>

                        <div className="name">
                            <span>Средний чек</span>
                        </div>

                        <span>Комментарий</span>
                    </div>

                    {items
                        .filter((i) => (cpl ? i : i.cpoType === tab))
                        .slice(0, all ? items.length : 2)
                        .map((item, idx) => {
                            const isGreen = offers ? offers.some((offer) => offer?.ratesArray?.find((f) => f.rateId === item._id)) : false;
                            const canRemove = !isGreen && firstParam !== "companies";

                            return (
                                <div className={`table__body ${isGreen ? "green" : ""}`} key={idx} style={{ "--countColumns": "3" }}>
                                    <span>{item?.percentAmount} %</span>

                                    <span>{item.averageBill} ₽</span>
                                    <TextAreaComment item={item} handleEditRates={handleEditRates} />
                                    {canRemove ? <i className="pi pi-trash delete" style={{ color: "#FF3D32", cursor: "pointer" }} onClick={() => confirmRemove(item._id)}></i> : null}
                                </div>
                            );
                        })}
                    {items.filter((i) => i.cpoType === tab).length > 2 ? (
                        <div className="table__button" onClick={() => setAll(!all)}>
                            {all ? "Скрыть ставки" : "Показать еще"}
                        </div>
                    ) : null}
                </div>
            );
        }

        if (cpl) {
            return (
                <div className="table">
                    <div className="table__head" style={{ "--countColumns": "3" }}>
                        {/* <span>Период действия</span> */}
                        <div className="name">
                            <span>Стоимость</span> <span className="desc">без НДС</span>
                        </div>
                        <div className="name">
                            <span>Стоимость</span> <span className="desc">с НДС</span>
                        </div>
                        <span>Комментарий</span>
                    </div>

                    {items.slice(0, all ? items.length : 2).map((item, idx) => {
                        const isGreen = offers ? offers.some((offer) => offer?.ratesArray?.find((f) => f.rateId === item._id)) : false;
                        const canRemove = !isGreen && firstParam !== "companies";

                        return (
                            <div className={`table__body ${isGreen ? "green" : ""}`} key={idx} style={{ "--countColumns": "3" }}>
                                {/* {item.indefinitely ? (
                                    <div className="date">
                                        <span>{moment(item.dateStart).format("DD.MM.YYYY")}</span>
                                    </div>
                                ) : (
                                    <div className="date">
                                        <span>c {item.dateStart ? moment(item.dateStart).format("DD.MM.YYYY") : null}</span>
                                        <span>до {item.dateEnd ? moment(item.dateEnd).format("DD.MM.YYYY") : null}</span>
                                    </div>
                                )} */}
                                <span>{Number(item.rate).toFixed(2)} ₽</span>
                                <span>{(item.rate * 1.22).toFixed(2)} ₽</span>
                                <TextAreaComment item={item} handleEditRates={handleEditRates} />
                                {canRemove ? <i className="pi pi-trash delete" style={{ color: "#FF3D32", cursor: "pointer" }} onClick={() => confirmRemove(item._id)}></i> : null}
                            </div>
                        );
                    })}
                    {items.filter((i) => i.cpoType === tab).length > 2 ? (
                        <div className="table__button" onClick={() => setAll(!all)}>
                            {all ? "Скрыть ставки" : "Показать еще"}
                        </div>
                    ) : null}
                </div>
            );
        }

        if (tab === "rateGradation") {
            return (
                <div className="table">
                    <div className="table__head" style={{ "--countColumns": "2" }}>
                        {/* <span>Период действия</span> */}
                        <span>Градации</span>
                        <span>Комментарий</span>
                    </div>

                    {items
                        .filter((i) => i.cpoType === tab)
                        .slice(0, all ? items.length : 2)
                        .map((item, idx) => {
                            const isGreen = offers ? offers.some((offer) => offer?.ratesArray?.find((f) => f.rateId === item._id)) : false;
                            const canRemove = !isGreen && firstParam !== "companies";

                            return (
                                <div className={`table__body ${isGreen ? "green" : ""}`} key={idx} style={{ "--countColumns": "2" }}>
                                    {/* {item.indefinitely ? (
                                        <div className="date">
                                            <span>{moment(item.dateStart).format("DD.MM.YYYY")}</span>
                                        </div>
                                    ) : (
                                        <div className="date">
                                            <span>c {item.dateStart ? moment(item.dateStart).format("DD.MM.YYYY") : null}</span>
                                            <span>до {item.dateEnd ? moment(item.dateEnd).format("DD.MM.YYYY") : null}</span>
                                        </div>
                                    )} */}
                                    <div className="gradation">
                                        <div className="table">
                                            <div className=" table__head">
                                                <span>Количество ЦД</span>
                                                <span>Стоимость без НДС</span>
                                            </div>
                                            {item.rateGradationArray.map((el, idx) => (
                                                <div key={idx} className="table__body">
                                                    <span>{`ЦД ${el.from.toLocaleString("ru-RU")} — ${el.to.toLocaleString("ru-RU")}`}</span>
                                                    <span className="count">{`${el.rate.toLocaleString("ru-RU")} ₽`}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <TextAreaComment item={item} handleEditRates={handleEditRates} />
                                    {canRemove ? <i className="pi pi-trash delete" style={{ color: "#FF3D32", cursor: "pointer" }} onClick={() => confirmRemove(item._id)}></i> : null}
                                </div>
                            );
                        })}
                    {items.filter((i) => i.cpoType === tab).length > 2 ? (
                        <div className="table__button" onClick={() => setAll(!all)}>
                            {all ? "Скрыть ставки" : "Показать еще"}
                        </div>
                    ) : null}
                </div>
            );
        }
        return (
            <div className="table">
                <div className="table__head" style={tab === "percentAmount" ? { "--countColumns": "2" } : { "--countColumns": "3" }}>
                    {/* <span>Период действия</span> */}
                    {cpl || tab === "rubPerOrder" ? (
                        <div className="name">
                            <span>Стоимость</span> <span className="desc">без НДС</span>
                        </div>
                    ) : null}
                    {cpl || tab === "rubPerOrder" ? (
                        <div className="name">
                            <span>Стоимость</span> <span className="desc">с НДС</span>
                        </div>
                    ) : null}

                    {tab === "percentAmount" ? <span>%</span> : null}
                    <span>Комментарий</span>
                </div>

                {items
                    .filter((i) => (cpl ? i : i.cpoType === tab))
                    .slice(0, all ? items.length : 2)
                    .map((item, idx) => {
                        const isGreen = offers ? offers.some((offer) => offer?.ratesArray?.find((f) => f.rateId === item._id)) : false;
                        const canRemove = !isGreen && firstParam !== "companies";

                        return (
                            <div className={`table__body ${isGreen ? "green" : ""}`} key={idx} style={tab === "rubPerOrder" ? { "--countColumns": "3" } : { "--countColumns": "2" }}>
                                {/* {item.indefinitely ? (
                                    <div className="date">
                                        <span>{moment(item.dateStart).format("DD.MM.YYYY")}</span>
                                    </div>
                                ) : (
                                    <div className="date">
                                        <span>c {item.dateStart ? moment(item.dateStart).format("DD.MM.YYYY") : null}</span>
                                        <span>до {item.dateEnd ? moment(item.dateEnd).format("DD.MM.YYYY") : null}</span>
                                    </div>
                                )} */}
                                {tab === "rubPerOrder" ? <span>{item?.rate?.toFixed(2)} ₽</span> : null}
                                {tab === "rubPerOrder" ? <span>{Number(item.rate * 1.22).toFixed(2)} ₽</span> : null}
                                {tab === "percentAmount" ? <span>{item.percentAmount}%</span> : null}
                                <TextAreaComment item={item} handleEditRates={handleEditRates} />
                                {canRemove ? <i className="pi pi-trash delete" style={{ color: "#FF3D32", cursor: "pointer" }} onClick={() => confirmRemove(item._id)}></i> : null}
                            </div>
                        );
                    })}
                {items.filter((i) => i.cpoType === tab).length > 2 ? (
                    <div className="table__button" onClick={() => setAll(!all)}>
                        {all ? "Скрыть ставки" : "Показать еще"}
                    </div>
                ) : null}
            </div>
        );
    }),
);

const TextAreaComment = ({ item, handleEditRates }) => {
    const [value, setValue] = useState(item.comments);

    return (
        <textarea
            value={value}
            className="input__comment"
            onChange={(e) => setValue(e.target.value)}
            onBlur={() => {
                handleEditRates({ ...item, comments: value });
            }}
        />
    );
};

export default RatesTableComponent;
